import React from 'react';
import styled from 'styled-components';

interface ButtonProps {
    onClick?: () => void;
    text?: string;
    className?: string;
    style?: React.CSSProperties;
}

const CheckoutButton = ({ onClick, text = "FINALIZAR COMPRA", className, style }: ButtonProps) => {
    return (
        <StyledWrapper className={className} style={style}>
            <button className="button" style={{ '--clr': '#344c3d' } as React.CSSProperties} onClick={onClick}>
                <span className="button__icon-wrapper">
                    <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="button__icon-svg" width={10}>
                        <path d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z" fill="currentColor" />
                    </svg>
                    <svg viewBox="0 0 14 15" fill="none" width={10} xmlns="http://www.w3.org/2000/svg" className="button__icon-svg button__icon-svg--copy">
                        <path d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z" fill="currentColor" />
                    </svg>
                </span>
                {text}
            </button>
        </StyledWrapper>
    );
}

const StyledWrapper = styled.div`
  width: 100%;
  
  .button {
    line-height: 1;
    text-decoration: none;
    display: flex;
    border: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    background-color: var(--clr);
    color: #fff;
    border-radius: 10rem;
    font-weight: 700;
    padding: 0.75rem 1.5rem;
    padding-left: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background-color 0.3s, transform 0.2s;
    width: 100%;
    height: 48px;
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .button__icon-wrapper {
    flex-shrink: 0;
    width: 25px;
    height: 25px;
    position: relative;
    color: var(--clr);
    background-color: #fff;
    border-radius: 50%;
    display: grid;
    place-items: center;
    overflow: hidden;
  }

  .button:hover {
    background-color: #2a3d31;
    transform: translateY(-1px);
  }

  .button:active {
    transform: scale(0.98);
  }

  .button:hover .button__icon-wrapper {
    color: #2a3d31;
  }

  .button__icon-svg--copy {
    position: absolute;
    transform: translate(-150%, 150%);
  }

  .button:hover .button__icon-svg:first-child {
    transition: transform 0.3s ease-in-out;
    transform: translate(150%, -150%);
  }

  .button:hover .button__icon-svg--copy {
    transition: transform 0.3s ease-in-out 0.1s;
    transform: translate(0);
  }`;

export default CheckoutButton;
